import { ResourceLinkCard } from "@/components/cards/resource-link-card";
import type { PendingResourceLink } from "@/hooks/use-resource-link-controller";
import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";

/** Props Interface */
interface TicketFormPendingResourceLinkItemProps {
	pendingLink: PendingResourceLink;
	onRemove: (link: string) => void;
}

export function TicketFormPendingResourceLinkItem({
	pendingLink,
	onRemove,
}: TicketFormPendingResourceLinkItemProps) {
	/** Render */
	return (
		<div className="h-stack items-center gap-2">
			<div className="min-w-0 flex-1">
				<ResourceLinkCard
					url={pendingLink.link}
					name={pendingLink.name}
				/>
			</div>
			<Button
				size="xxs"
				variant="ghost"
				icon={<Icon name="Trash2" />}
				onClick={() => onRemove(pendingLink.link)}
				data-cy="ticket-pending-resource-link-remove-button"
			/>
		</div>
	);
}
